import {
	GET_CAMPAIGN,
	GET_CAMPAIGNS,
	ADD_CAMPAIGN,
	UPDATE_CAMPAIGN,
	REMOVE_CAMPAIGN,
	ERR_CAMPAIGN,
	LOADING_CAMPAIGNS
} from "../actions/actionTypes";

const initialState = {
	campaignInfo: {
		name: '',
		description: '',
		status: 'Deactivated',
		banners: [],
		offerings: []
	},
	campaignList: [],
	// loading: true,
	loading: false,
	errors: {},
};

export default function campaignReducer(state = initialState, action) {
	const { type, payload } = action;

	switch (type) {
		case GET_CAMPAIGNS:
			return {
				...state,
				campaignList: payload,
				loading: false,
			};
		case GET_CAMPAIGN:
			return {
				...state,
				campaignInfo: payload,
				loading: false,
			};
		case UPDATE_CAMPAIGN:
			return {
				...state,
				campaignList: state.campaignList.map((campaign) =>
					campaign._id === payload.id
						? { ...campaign, payload }
						: campaign
				),
				loading: false,
			};
		case ADD_CAMPAIGN:
			return {
				...state,
				campaignInfo: { ...state.campaign, payload },
				loading: false,
			};
		case REMOVE_CAMPAIGN:
			return {
				...state,
				campaignList: state.campaignList.filter(
					(campaign) => campaign._id !== payload
				),
				loading: false,
			};
		case ERR_CAMPAIGN:
			return {
				...state,
				errors: payload,
				loading: false,
				profile: null,
			};
		case LOADING_CAMPAIGNS:
			return {
				...state,
				loading: payload
			};
		default:
			return state;
	}
}
